<template>
    <div class="program-wrap">
        <bread-crumb :bread-list="breadList" />

        <div class="program-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">栏目管理</span>
            </div>
            <div class="search-wrap">
                <div class="search-show-wrap">
                    <el-input class="search-input"
                              size="small"
                              placeholder="请输入栏目名称"
                              v-model="selectForm.programName"
                              @keyup.enter.native="handleSearch">
                        <i slot="suffix"
                           class="iconfont icon-search"
                           @click="handleSearch"></i>
                    </el-input>
                    <div class="more-search"
                         @click="isMoreShow=!isMoreShow">
                        <span class="more-search-text">高级搜索</span>
                        <i class="iconfont icon-drop_down"
                           :class="[{'is-reverse': isMoreShow}]"></i>
                    </div>
                </div>
                <el-button size="small"
                           @click="handleAddProgram">新增栏目</el-button>
            </div>

            <div class="hide-wrap"
                 v-if="isMoreShow">
                <div class="option-wrap">
                    <div class="option-item">
                        <span class="label">栏目名称</span>
                        <el-input placeholder="请输入栏目名称"
                                  :style="{width: '240px'}"
                                  v-model="selectForm.programName">
                        </el-input>
                    </div>
                    <div class="option-item">
                        <span class="label">状态</span>
                        <el-select v-model="selectForm.status"
                                   placeholder="请选择"
                                   size="small"
                                   :style="{width: '240px'}"
                                   @change="selectChange"
                                   clearable>
                            <el-option label="全部"
                                       value="">
                            </el-option>
                            <el-option label="已上线"
                                       :value="true">
                            </el-option>
                            <el-option label="未上线"
                                       :value="false">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="option-item">
                        <span class="label">上线时间</span>
                        <el-date-picker size="small"
                                        clearable
                                        clear-icon="el-icon-error"
                                        v-model="selectForm.addedTime"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="yyyy-mm-dd"
                                        end-placeholder="yyyy-mm-dd"
                                        value-format="yyyy-MM-dd"
                                        :style="{width: '240px'}"
                                        :picker-options="datePickerOptions">
                        </el-date-picker>
                    </div>

                    <div class="option-item">
                        <span class="label">创建时间</span>
                        <el-date-picker size="small"
                                        clearable
                                        clear-icon="el-icon-error"
                                        v-model="selectForm.createTime"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="yyyy-mm-dd"
                                        end-placeholder="yyyy-mm-dd"
                                        value-format="yyyy-MM-dd"
                                        :style="{width: '240px'}"
                                        :picker-options="datePickerOptions">
                        </el-date-picker>
                    </div>
                    <div class="select-btn-wrap">
                        <el-button type="primary"
                                   size="small"
                                   @click="handleSearch">查询</el-button>
                        <el-button type="info"
                                   size="small"
                                   plain
                                   @click="resetSearch">重置</el-button>
                    </div>
                </div>
            </div>

            <div class="table-wrap">
                <el-table :data="dataList"
                          v-loading="loading"
                          stripe
                          style="width: 100%">
                    <el-table-column min-width="90px"
                                     label="序号">
                        <template slot-scope="scope">
                            <span>{{  scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="programName"
                                     min-width="140px"
                                     label="栏目名称">
                    </el-table-column>
                    <el-table-column prop="departmentName"
                                     min-width="120px"
                                     label="科室">
                    </el-table-column>
                    <el-table-column min-width="150px"
                                     label="上线时间">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.addedTime|formatDate }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="150px"
                                     label="下线时间">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.dismountedTime|formatDate }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="150px"
                                     label="创建时间">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.createTime|formatDate }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="creator"
                                     min-width="140px"
                                     label="创建者">
                    </el-table-column>
                    <el-table-column min-width="100px"
                                     label="状态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="success"
                                          class="item">
                                </el-badge>
                                <span class="status_text">已上线</span>
                            </div>
                            <div v-else
                                 class="status-warp">
                                <el-badge is-dot
                                          type="info"
                                          class="item">
                                </el-badge>
                                <span class="status_text">未上线</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right"
                                     label="排序"
                                     min-width="90">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status && isStatsShow"
                                 class="status-on">
                                <i class="iconfont icon-paixushang icon-off"
                                   v-if="scope.row.noMoveUp"></i>
                                <i class="iconfont icon-paixushang icon-on"
                                   v-else
                                   @click="handleMoveUp(scope.row.programId)"></i>

                                <i class="iconfont icon-paixuxia icon-off"
                                   v-if="scope.row.noMoveDown"></i>
                                <i class="iconfont icon-paixuxia icon-on"
                                   v-else
                                   @click="handleMoveDown(scope.row.programId)"></i>
                            </div>
                            <div v-else
                                 class="status-off">
                                <i class="iconfont icon-paixushang"></i>
                                <i class="iconfont icon-paixuxia"></i>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right"
                                     label="操作"
                                     width="190">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status">
                                <span @click="handleClick(scope.row.programId, 'off')"
                                      class="link-btn">下线</span>
                                <span @click="showEdu(scope.row)"
                                      class="link-btn">试卷管理</span>
                            </div>
                            <div v-else>
                                <span @click="handleClick(scope.row.programId, 'on')"
                                      class="link-btn">上线</span>
                                <span @click="showEdu(scope.row)"
                                      class="link-btn">试卷管理</span>
                                <span @click="handleClick(scope.row.programId, 'edit')"
                                      class="link-btn">编辑</span>
                                <span @click="hanldeDialogVisible(scope.row)"
                                      class="link-btn">删除</span>
                            </div>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="pageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>

        <message-box :dialog-visible="dialogVisible"
                     :id="programId"
                     warning-text="确认将此栏目删除？"
                     @handleConfirm="handleConfirm"
                     @handleClose="handleClose" />
        <el-dialog  title="试卷管理"
                    :visible.sync="isEduShow"
                    :close-on-click-modal="false"
                    class="choose-exma-dialog"
                    @close="cancelChoose"
                    width="720px">
            <div class="search-exam">
                <el-input class="search-doctor"
                            placeholder="请输入考试名称"
                            v-model="examinationName"
                            @keyup.enter.native="searchExam">
                    <i slot="suffix"
                        class="iconfont icon-search"
                        @click="searchExam"></i>
                </el-input>
            </div>
            <div class="table">
                <el-table :data="eduList"
                          :row-key="getRowKeys"
                          @select="handleSelectionChange"
                          stripe
                          ref="chooseEduTable"
                          v-loading="eduLoading"
                          style="width: 100%">
                    <el-table-column type="selection"
                                     :reserve-selection="true"
                                     width="60">
                    </el-table-column>
                    <el-table-column prop="name"
                                    label=考试名称>
                        <template slot-scope="scope">
                            {{scope.row.examinationName}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="name"
                                    fixed="right"
                                    width="60px"
                                    label=总分>
                        <template slot-scope="scope">
                            {{scope.row.totalScore}}
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-wrap">
                    <el-pagination background
                                style="margin-bottom:0"
                                @current-change="examPageChange"
                                :current-page.sync="pageEdu.pageNum"
                                :page-size="pageEdu.pageSize"
                                layout="total, prev, pager, next, jumper"
                                :total="pageEdu.total">
                    </el-pagination>
                </div>
            </div>

            <span slot="footer"
                  class="dialog-footer">
                <el-button type="warning"
                            size="small"
                            :disabled="eduList.length<=0"
                            @click="sureChooseModule()">确 定</el-button>
                <el-button size="small"
                            type="info"
                            plain
                            @click="cancelChoose">取 消</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import shortcuts from '@/utils/pickerOptions'
import { postProgramList, deleteProgram, postDismountedProgram, postShelfProgram, getMoveUp, getMoveDown } from '@/api/program'
import { getExamList, postRelation, postAddExam } from '@/api/expert'
import MessageBox from '@/components/MessageBox'
export default {
    name: 'program',
    data () {
        return {
            examinationName: '',
            examLoading: false,
            relationId: '',
            isEduShow: false,
            eduLoading: false,
            eduList: [],
            eduData: {},
            examChooseList: [],
            pageEdu: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            isMoreShow: false,
            loading: false,
            dialogVisible: false,
            programId: '',
            datePickerOptions: {
                shortcuts: shortcuts
            },
            breadList: [{ label: '运营管理' }, { label: '栏目管理' }],
            dataList: [],
            selectForm: {
                programName: '',
                status: '',
                addedTime: '',
                createTime: ''
            },
            isStatsShow: true,
            page: {
                current: 1,
                total: 1,
                pageSize: 15
            }
        }
    },
    components: {
        MessageBox
    },
    filters: {
        formatDate (value) {
            if (value) {
                return value.substring(0, 16)
            } else {
                return ''
            }
        }
    },
    methods: {
        // 试卷管理 开始
        getRowKeys (row) {
            return row.id
        },
        examPageChange (val) {
            this.pageEdu.pageNum = val
            this.getEduList()
        },
        // 考试名称搜索
        searchExam () {
            this.pageEdu.pageNum = 1
            this.getEduList()
        },
        async showEdu (data) {
            this.isEduShow = true
            this.eduLoading = true
            this.eduData = data
            let params = {
                current: 1,
                size: 1000,
                relationId: data.programId
            }
            this.relationId = data.programId
            this.getBandExam(params)
        },
        cancelChoose () {
            this.pageEdu.pageNum = 1
            this.examinationName = ''
            this.isEduShow = false
            this.$refs.chooseEduTable.clearSelection()
        },
        async getBandExam (params) {
            this.examChooseList = []
            const { results } = await postRelation(params)
            results.records.forEach(item => {
                this.examChooseList.push(item.examId)
            })
            this.getEduList()
        },
        async getEduList () {
            this.eduLoading = true
            let params = {
                status: 0,
                type: 0,
                examinationName: this.examinationName,
                pageSize: this.pageEdu.pageSize,
                pageNum: this.pageEdu.pageNum
            }
            const { list, total } = await getExamList(params)
            this.eduList = list || []
            this.pageEdu.total = total
            this.$nextTick(() => {
                // 默认选中
                this.eduList.forEach(item => {
                    if (this.examChooseList.findIndex(q => q === item.id) !== -1) {
                        this.$refs.chooseEduTable.toggleRowSelection(item, true)
                    } else {
                        this.$refs.chooseEduTable.toggleRowSelection(item, false)
                    }
                })
            })
            this.eduLoading = false
        },
        async sureChooseModule () {
            this.examLoading = true
            const param = {
                examIds: this.examChooseList,
                relationId: this.relationId,
                relationType: '2'
            }
            const { results } = await postAddExam(param)
            if (results === 'ok') {
                this.$message.success('选择试卷成功')
            } else {
                this.$message.erning('选择试卷失败')
            }
            this.pageEdu.pageNum = 1
            this.examinationName = ''
            this.$refs.chooseEduTable.clearSelection()
            this.examLoading = false
            this.isEduShow = false
        },
        handleSelectionChange (value, row) {
            let index = this.examChooseList.indexOf(row.id)
            if (index === -1) {
                this.examChooseList.push(row.id)
            } else {
                this.examChooseList.splice(index, 1)
            }
        },
        // 试卷管理 结束
        handleAddProgram () {
            this.$router.push('/operation/program/add')
        },
        pageChange (val) {
            this.query(val)
        },
        handleClick (programId, type) {
            this.programId = programId
            if (type === 'off') {
                this.handleOff()
            }
            if (type === 'on') {
                this.handleOn()
            }
            if (type === 'edit') {
                this.$router.push({ path: '/operation/program/editor', query: { programId: programId } })
            }
        },
        async handleOff () {
            this.loading = true
            const { state } = await postDismountedProgram(this.programId)
            if (state === 200) {
                this.$message({
                    message: '下线栏目成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.query(this.page.current)
            }
        },
        async handleOn () {
            this.loading = true
            const { state } = await postShelfProgram(this.programId)
            if (state === 200) {
                this.$message({
                    message: '上线栏目成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.query(this.page.current)
            }
        },
        async handleMoveUp (programId) {
            const { state } = await getMoveUp(programId)
            if (state === 200) {
                this.query(this.page.current)
            }
        },

        async handleMoveDown (programId) {
            const { state } = await getMoveDown(programId)
            if (state === 200) {
                this.query(this.page.current)
            }
        },
        resetSearch () {
            this.selectForm.programName = ''
            this.selectForm.status = ''
            this.selectForm.addedTime = ''
            this.selectForm.createTime = ''
            this.query(1)
        },
        selectChange () {
            this.query(1)
        },
        handleSearch () {
            this.query(1)
        },
        hanldeDialogVisible (row) {
            this.programId = row.programId
            this.dialogVisible = true
        },
        handleClose () {
            this.dialogVisible = false
        },
        handleConfirm (programId) {
            this.handleDeleteProgram(programId)
        },
        async handleDeleteProgram (programId) {
            this.loading = true
            const { state } = await deleteProgram(programId)
            if (state === 200) {
                this.$message({
                    message: '删除栏目成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '1000'
                })
                this.query(this.page.current)
                this.dialogVisible = false
            }
        },
        query (current) {
            this.page.current = current
            this.queryProgramList()
        },
        queryShow () {
            const { programName, status, addedTime, createTime } = this.selectForm
            let flag = programName || status || addedTime || createTime
            this.isStatsShow = !flag
        },
        async queryProgramList () {
            let addedTimeStart = ''
            let addedTimeEnd = ''
            if (this.selectForm.addedTime) {
                addedTimeStart = this.selectForm.addedTime[0] + ' 00:00:00'
                addedTimeEnd = this.selectForm.addedTime[1] + ' 23:59:59'
            }
            let createTimeStart = ''
            let createTimeEnd = ''
            if (this.selectForm.createTime) {
                createTimeStart = this.selectForm.createTime[0] + ' 00:00:00'
                createTimeEnd = this.selectForm.createTime[1] + ' 23:59:59'
            }
            let params = {
                programName: this.selectForm.programName,
                status: this.selectForm.status,
                addedTimeStart: addedTimeStart,
                addedTimeEnd: addedTimeEnd,
                createTimeStart: createTimeStart,
                createTimeEnd: createTimeEnd,
                size: this.page.pageSize,
                current: this.page.current
            }
            this.loading = true
            this.dataList = []
            const { results, total } = await postProgramList(params)
            if (results.length > 0) {
                for (let i = 0; i < results.length; i++) {
                    if (results[0].priority !== 0 && this.page.current === 1) {
                        this.$set(results[0], 'noMoveUp', true)
                    }
                    if (results[i].priority === 1) {
                        this.$set(results[i], 'noMoveDown', true)
                    }
                }
                this.dataList = results
                this.page.total = total
            } else {
                if (this.page.current > 1) {
                    this.page.current -= 1
                    this.queryProgramList()
                }
            }
            this.queryShow()
            this.loading = false
        },
        init () {
            this.queryProgramList()
        }
    },
    mounted () {
        this.init()
    }
}
</script>

<style lang="scss">
.program-wrap {
    .program-content {
        min-height: 600px;
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        overflow: auto;
        .title-wrap {
            font-size: 0;
            padding-bottom: 20px;
            height: 16px;
            line-height: 16px;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }

        .search-wrap {
            display: flex;
            justify-content: space-between;
            .search-show-wrap {
                display: flex;
            }
            .more-search {
                font-size: 0;
                color: #666;
                padding-left: 10px;
                cursor: pointer;
            }
            .more-search-text {
                font-size: 14px;
                line-height: 32px;
                padding-right: 3px;
            }
            .icon-drop_down {
                display: inline-block;
                font-size: 12px;
                color: #999;
                transition: transform 0.3s;
                transform: rotateZ(180deg);
                &.is-reverse {
                    transform: rotateZ(0deg);
                }
            }
        }

        .hide-wrap {
            margin-top: 8px;
            background: #f7f7f7;
            border: 1px solid #e6e6e6;
            padding-left: 20px;
            .option-wrap {
                display: flex;
                flex-wrap: wrap;
                &:last-child {
                    margin-bottom: 0;
                }
                .option-item {
                    display: inline-block;
                    font-size: 0;
                    margin: 20px 20px 20px 0;
                    .label {
                        padding-right: 10px;
                        font-size: 14px;
                        color: #666;
                        display: inline-block;
                        width: 56px;
                        text-align: right;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                    .el-select {
                        margin-right: 10px;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                    .el-input {
                        margin-right: 10px;
                        .el-input__inner {
                            height: 32px;
                        }
                    }
                    .el-date-editor {
                        margin-right: 10px;
                    }
                }
                .select-btn-wrap {
                    font-size: 0;
                    margin-top: 20px;
                    .el-button--small {
                        width: 80px;
                        padding: 8px 15px;
                        font-size: 14px;
                    }
                    .el-button--info.is-plain {
                        background: #f5f5f5;
                        border-color: #cccccc;
                        color: #666;
                    }
                }
            }
        }

        .table-wrap {
            margin-top: 20px;
            .table-none {
                height: 400px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .icon {
                    font-size: 100px;
                }
                span {
                    line-height: 14px;
                }
            }
            .link-btn {
                color: $a-link;
                cursor: pointer;
                font-size: 12px;
                display: inline-block;
                height: 14px;
                line-height: 14px;
                border-right: 1px solid $a-link;
                margin-right: 6px;
                padding-right: 6px;
                &:last-child {
                    border-right: none;
                    margin-right: 0;
                    padding-right: 0;
                }
            }
            .status-warp {
                line-height: 12px;
                .el-badge {
                    height: 10px;
                    .el-badge__content {
                        width: 6px;
                        height: 6px;
                    }
                    .el-badge__content--success {
                        background: #4acfb1;
                    }
                    .el-badge__content--info {
                        background: #cccccc;
                    }
                }
                .status_text {
                    margin-left: 10px;
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #333333;
                    line-height: 12px;
                }
            }

            .status-on {
                .icon-off {
                    color: #ccc;
                }
                .icon-on {
                    cursor: pointer;
                    color: #3b8fd9;
                }
                .icon-paixuxia {
                    font-size: 16px;
                }
                .icon-paixushang {
                    font-size: 16px;
                    margin-right: 20px;
                }
            }
            .status-off {
                .icon-paixuxia {
                    font-size: 16px;
                    color: #ccc;
                }
                .icon-paixushang {
                    font-size: 16px;
                    color: #ccc;
                    margin-right: 20px;
                }
            }
        }
    }
    .choose-exma-dialog {
        .search-exam {
            margin-bottom: 20px;
            .search-doctor {
                width: 319px;
                vertical-align: middle;
                .el-input__inner {
                    border-radius: 3px;
                    border-color: #dcdcdc;
                    padding: 8px 32px 8px 10px;
                    height: 32px;
                    font-size: 12px;
                    &::-webkit-input-placeholder {
                        font-size: 12px;
                    }
                }
                .el-input__suffix {
                    background: $color-primary;
                    color: #fff;
                    right: 0;
                    cursor: pointer;
                    border-radius: 0 3px 3px 0;

                    i {
                        display: inline-block;
                        width: 36px;
                        font-size: 14px;
                        line-height: 32px;
                        border-radius: 3px;
                    }
                }
            }
        }
        .el-table .cell {
            display: block;
        }
        .el-dialog__footer {
            text-align: center;
        }
        .el-table__header-wrapper  .el-checkbox{//找到表头那一行，然后把里面的复选框隐藏掉
            display:none
        }
    }
}
</style>
